import CONFIG from "../../../config";

const SSN_HELP_TEXT = "Please enter a 9-digit SSN. If the patient's SSN is unknown, you may use 000-00-0000 as a placeholder.";

export const DEFAULT_ORIGINAL_FIELDS = [
  'diagnosis',
  'comment',
  'firstname',
  'lastname',
  'phone',
  'ssn',
  'mrn',
  'birthdate',
  'full_address',
  'insurance_provider',
  'policy_number',
];

export const geocoderApiOptions = {
  country: 'us',
  language: 'en',
};

export const MAPBOX_ACCESS_TOKEN = CONFIG.MAPBOX_ACCESS_TOKEN;

export const FIELD_TYPES = [
  {
    value: 'label',
    label: 'Label',
  },
  {
    value: 'text',
    label: 'Text Field',
  },
  {
    value: 'textarea',
    label: 'Text Area',
  },
  {
    value: 'numeric',
    label: 'Numeric Field',
  },
  {
    value: 'single_choice',
    label: 'Radio Button',
  },
  {
    value: 'multiple_choice',
    label: 'Checkbox',
  },
  {
    value: 'date',
    label: 'Date Field',
  },
  {
    value: 'phone',
    label: 'Phone Field',
  },
  {
    value: 'address',
    label: 'Address Field',
  },
];

export const DEFAULT_REFERRAL_FORM_FIELD = [
  {
    field: 'ssn',
    label: 'SSN',
    size: 12,
    required: true,
    hidden: false,
    kind: 'text',
    choices: [],
    helpText: SSN_HELP_TEXT
  },
  {
    field: 'mrn',
    label: 'MRN',
    size: 12,
    required: true,
    hidden: false,
    kind: 'text',
    choices: [],
  },
  {
    field: 'firstname',
    label: 'First Name',
    size: 6,
    required: true,
    hidden: false,
    kind: 'text',
    choices: [],
  },
  {
    field: 'lastname',
    label: 'Last Name',
    size: 6,
    required: true,
    hidden: false,
    kind: 'text',
    choices: [],
  },
  {
    field: 'birthdate',
    label: 'Birthdate',
    size: 6,
    required: true,
    hidden: false,
    kind: 'date',
    choices: [],
  },
  {
    field: 'phone',
    label: 'Phone',
    size: 6,
    required: true,
    hidden: false,
    kind: 'phone',
    choices: [],
  },
  {
    field: 'full_address',
    label: 'Address',
    size: 12,
    required: true,
    hidden: false,
    kind: 'address',
    choices: [],
  },
  {
    field: 'insurance_provider',
    label: 'Insurance Provider',
    size: 6,
    required: true,
    hidden: false,
    kind: 'text',
    choices: [],
  },
  {
    field: 'policy_number',
    label: 'Policy Number',
    size: 6,
    required: true,
    hidden: false,
    kind: 'text',
    choices: [],
  },
  {
    field: 'diagnosis',
    label: 'Diagnosis',
    size: 12,
    required: true,
    hidden: false,
    kind: 'text',
    choices: [],
  },
  {
    field: 'comment',
    label: 'Comment',
    size: 12,
    required: false,
    hidden: false,
    kind: 'textarea',
    choices: [],
  },
];

export const DEFAULT_INTERNAL_REFERRAL_FORM_FIELD = [
  ...DEFAULT_REFERRAL_FORM_FIELD
];
